// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var AmplifyErrorCode = /*#__PURE__*/function (AmplifyErrorCode) {
  AmplifyErrorCode["NoEndpointId"] = "NoEndpointId";
  AmplifyErrorCode["PlatformNotSupported"] = "PlatformNotSupported";
  AmplifyErrorCode["Unknown"] = "Unknown";
  AmplifyErrorCode["NetworkError"] = "NetworkError";
  return AmplifyErrorCode;
}(AmplifyErrorCode || {});
export { AmplifyErrorCode };
